// extracted by mini-css-extract-plugin
export var messageSideLeft = "_j2-1";
export var messageSideRight = "_j2-2";
export var subscribeToBackInStockBubbleContainer = "_j2-0";